import * as React from 'react';
import { connect } from 'react-redux';

import '../../Main.scss';

import { FSModels } from '@finagraph/financial-statement-editor';

import {
    Button,
    Col,
    Container,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row
} from 'reactstrap';

import { FinancialStatementRenderData } from './UtilTypes';
import { StringFormat } from '../../../Utils/StringUtils';

import { ApplicationState } from '../../../Store';
import {
    GetValidLocationToMoveSectionContents
} from '../../../Store/FinancialStatements';

import { 
    PortalTextFinancialStatements,
    PortalTextCommon,
 } from '../../../Models/Api/strongbox.financialportal';

type InjectedReduxState = {
    validDestinations: FSModels.MoveLineItemOption[];
}

type InjectedActionCreators = {};

type DeleteNonEmptySectionModalProps = {
    lineItem: FSModels.FinancialStatementLineItemViewModel;
    onClose: (destinationSectionId?: string) => void;
    renderData: FinancialStatementRenderData;
    financialStatementsText?: PortalTextFinancialStatements;
    commonText?: PortalTextCommon;
}

type Props = DeleteNonEmptySectionModalProps & InjectedReduxState & InjectedActionCreators;

const DeleteNonEmptySectionModalComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        lineItem,
        onClose,
        validDestinations,
        financialStatementsText
    } = props;

    const [selectedDestination, setSelectedDestination] = React.useState<{
        id: string;
        label: string;
    } | undefined> (undefined);

    return (
        <Modal
            className={`flight-modal`}
            isOpen={true}
            backdrop={'static'}
        >
            <ModalHeader toggle={() => onClose()}>{StringFormat(financialStatementsText?.templateDeleteLineItem || '{0}', lineItem.captionText)}</ModalHeader>
            <ModalBody>
                <Container className={`control-region control-region-lender`}>
                    <Row>
                        <Col>
                            <p>{financialStatementsText?.unableToDeleteNonEmptyCategory || ''}</p>
                            <p>{financialStatementsText?.chooseAnotherDestinationFromList || ''}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h1>{`financialStatementsText?.OtherClassifications || '':`}</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col
                            className={'move-financial-statement-valid-destination-list'}
                        >
                            {
                                validDestinations
                                    .filter(potentialDestination => potentialDestination.canMoveToThisLocation)
                                    .map((destination, index) => {
                                        return (
                                            <Row
                                                key={`section-destination-${destination.sectionId || ''}-${index}`}
                                                className={`selectable-row${(!!selectedDestination && destination.sectionId === selectedDestination.id) ? ' selected-row' : ''}`}
                                                onClick={() => {
                                                    setSelectedDestination({
                                                        id: destination.sectionId || '',
                                                        label: destination.locationDisplayName
                                                    });
                                                }}
                                            >
                                                <Col>
                                                    <span>{destination.locationDisplayName}</span>
                                                </Col>
                                            </Row>
                                        )
                                    })
                            }
                        </Col>
                    </Row>
                    {
                        !!selectedDestination && (
                            <Row style={{
                                marginTop: '25px'
                            }}>
                                <Col>
                                    <p>{StringFormat(financialStatementsText?.templateMoveAccountsAndDelete || '{0}{1}', selectedDestination.label, lineItem.captionText)}</p>
                                </Col>
                            </Row>
                        )
                    }
                </Container>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="secondary"
                    onClick={() => onClose()}
                >
                    Cancel
                </Button>
                <Button
                    color="primary"
                    onClick={() => onClose(selectedDestination!.id)}
                    disabled={!selectedDestination}
                >
                    Move and Delete
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export const DeleteNonEmptySectionModal = connect<InjectedReduxState, InjectedActionCreators, DeleteNonEmptySectionModalProps, ApplicationState>(
    (appState: ApplicationState, props: DeleteNonEmptySectionModalProps) => {
        return {
            validDestinations: GetValidLocationToMoveSectionContents(appState, props.lineItem.id)
        }
    }
)(DeleteNonEmptySectionModalComponent);
